enum MeetRequirementsOption {
  Yes = 'Yes',
  No = 'No',
}

export default MeetRequirementsOption;
